import React, { memo } from "react";
import { format } from "date-fns";
import { DeleteIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/layout";
import { IconButton } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { Tag } from "@chakra-ui/tag";
import { CherryPayApi } from "../../api/models";
import { EditIcon } from "../../styles/icons";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";

interface TermsConditionsTableProps {
  venues: any[] | null;
  business: CherryPayApi.BusinessSummary;
  isLoading: boolean;
  disableActions?: boolean;
  onClickEditVenue: (venue: CherryPayApi.VenueDocument) => void;
  onClickDeleteVenue: (venue: CherryPayApi.VenueDocument) => void;
}

export const TermsConditionsTable = memo(
  ({
    venues,
    business,
    isLoading,
    disableActions,
    onClickEditVenue,
    onClickDeleteVenue,
  }: TermsConditionsTableProps) => {
    return (
      <Box w="100%" overflowX="auto">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Name of Promotion</Th>
              <Th>Game Type</Th>
              <Th>Link</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {(venues ?? []).map((venue) => (
              <Tr key={venue.id}>
                <Td>{venue.name}</Td>
                <Td>{venue.gameType}</Td>
                <Td>
                  <a
                    href={`/view/${business.BusinessId}/terms-conditions/${venue.id}`}
                    target="_blank"
                    style={{ textDecoration: "underline" }}
                  >
                    Link
                  </a>
                </Td>
                <Td width="0.1%" whiteSpace="nowrap">
                  <IconButton
                    aria-label="Edit"
                    title="Edit"
                    icon={<EditIcon />}
                    size="sm"
                    isDisabled={disableActions}
                    onClick={() => onClickEditVenue(venue)}
                  />
                  {venue.createdAt && (
                    <IconButton
                      marginLeft="1"
                      aria-label="Delete"
                      title="Delete"
                      icon={<DeleteIcon />}
                      size="sm"
                      isDisabled={disableActions}
                      onClick={() => onClickDeleteVenue(venue)}
                    />
                  )}
                </Td>
              </Tr>
            ))}
            {venues?.length === 0 && !isLoading && (
              <Tr>
                <Td colSpan={3} textAlign="center">
                  Nothing created.
                </Td>
              </Tr>
            )}
            {(!venues || isLoading) && (
              <Tr>
                <Td colSpan={3} textAlign="center">
                  <LoadingIndicator color="gray.600" />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    );
  }
);
